<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">Reporte de Conciliación Tickets / Facturas</div>

    <div class="box-container">
      <div class="box-filtres">
        <table>
          <tbody>
            <tr>
              <td width="170px">
                <input id="fechainicio" placeholder="Fecha inicio" type="text" class="form-control" autocomplete="off"
                  datatype="fecha" />
              </td>

              <td width="170px">
                <input id="fechafin" placeholder="Fecha final" type="text" class="form-control" autocomplete="off"
                  datatype="fecha" />
              </td>

              <td style="white-space: nowrap;">
                <button class="btn btn-warning" type="button" :disabled="isBusy" @click="getReporteVentasFactura">
                  Consultar
                </button>
              </td>

              <td style="white-space: nowrap;">
                <button class="btn btn-success" type="button" :disabled="isBusy" @click="exportarExcel">
                  <i class="fa-regular fa-file-excel"></i>
                  <span class="ml-1">Exportar</span>
                </button>
              </td>

              <!-- Mensaje en la MISMA línea -->
              <td style="min-width: 340px;">
                <span v-if="busyText" class="msg msg-info">
                  <i class="fa fa-spinner fa-spin"></i> {{ busyText }}
                </span>
                <span v-else-if="errorMsg" class="msg msg-error">
                  {{ errorMsg }}
                </span>
                <span v-else-if="infoMsg" class="msg msg-muted">
                  {{ infoMsg }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div id="containter-table" class="containter-table">
        <table id="table1" width="100%" class="display nowrap" style="width: 100%">
          <thead>
            <tr>
              <th>TimeStamp</th>
              <th>Fecha</th>
              <th class="text-center">Hora</th>
              <th>Mang</th>
              <th>Producto</th>
              <th>Operador</th>
              <th class="text-center">Flota</th>
              <th>Placa</th>
              <th>Cliente</th>
              <th>Ticket</th>
              <th>M.Pago.1</th>
              <th>M.Pago.2</th>
              <th>M.Pago.3</th>
              <th class="text-center">L.inicial</th>
              <th class="text-center">L.final</th>
              <th class="text-center">P.Llenado</th>
              <th class="text-center">Precio</th>
              <th class="text-center">Cant</th>
              <th class="text-center">Unidad</th>
              <th class="text-center">Subtotal</th>
              <th class="text-center">Descuento</th>
              <th class="text-center">Venta Total</th>
              <th class="text-center">Recaudar</th>
              <th class="text-center">Recaudado</th>
              <th class="text-center">Total</th>
              <th class="text-center">Factura</th>
              <th class="text-center">Cant(m3)</th>
              <th class="text-center">Precio(m3)</th>
              <th class="text-center">UUID</th>
              <th class="text-center">RFC</th>
              <th class="text-center">Receptor</th>
              <th class="text-center">Fecha</th>
            </tr>
          </thead>
        </table>
      </div>

      <div class="mt-2">
        <table width="300px" class="table font-oswald">
          <tbody>
            <tr>
              <td class="subtable" width="150px">TRANSACCIONES</td>
              <td class="subtable b text-right">{{ totalventas }}</td>
            </tr>
            <tr>
              <td class="subtable">TOTAL CANTIDAD</td>
              <td class="subtable b text-right">{{ fcantidad }}</td>
            </tr>
            <tr>
              <td class="subtable">TOTAL IMPUESTOS</td>
              <td class="subtable b text-right">{{ ftotalimpuestos }}</td>
            </tr>
            <tr>
              <td class="subtable">TOTAL VENTAS</td>
              <td class="subtable b text-right">{{ ftotales }}</td>
            </tr>
            <tr>
              <td class="subtable">FECHA INICIO</td>
              <td class="subtable b text-right">{{ fecha_inicio_reporte }}</td>
            </tr>
            <tr>
              <td class="subtable">FECHA FINAL</td>
              <td class="subtable b text-right">{{ fecha_final_reporte }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="!permiso_lista">
        {{ person.nombre }}, {{ GLOBAL.MENSAJE.SIN_AUTORIZACION }}
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import ReporteService from "../../service/ReporteService";

export default {
  name: "VentasConciliadasView",
  data() {
    return {
      GLOBAL,
      reporteService: new ReporteService(),
      person: JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY)),

      permiso_lista: false,
      reporte: [],
      datatable: null,

      totalventas: 0,
      totalimpuestos: 0,
      totales: 0,
      totalCantidad: 0,
      fcantidad: "0",
      ftotalimpuestos: "$ 0",
      ftotales: "$ 0",
      fecha_inicio_reporte: "",
      fecha_final_reporte: "",

      loading: false,
      loadingExport: false,

      busyText: "",
      errorMsg: "",
      infoMsg: "",
    };
  },

  computed: {
    isBusy() {
      return this.loading || this.loadingExport;
    },
  },

  created() {
    this.permiso_lista = this.person.funciones.includes(GLOBAL.PERMISOS.REPORTE.HOROMETRO);
  },

  mounted() {
    const fecha = new Date();
    const formattedDate = `${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(2, "0")}-${String(
      fecha.getDate()
    ).padStart(2, "0")}`;

    $("#fechainicio").val(`${formattedDate} 00:00`);
    $("#fechafin").val(`${formattedDate} 23:59`);

    // Mantén tu datetimepicker
    $("input[datatype='fecha']").datetimepicker();

    this.initializeDataTable();
  },

  beforeRouteLeave(to, from, next) {
    try {
      if (this.datatable) {
        this.datatable.clear();
        this.datatable.draw();
        this.datatable.destroy();
        this.datatable = null;
      }
    } catch (e) {
      // noop
    }
    next();
  },

  methods: {
    resetMsgs() {
      this.busyText = "";
      this.errorMsg = "";
      this.infoMsg = "";
    },

    extractArrayFromResponse(response) {
      // Soporta ambos formatos:
      // 1) response.data = []
      // 2) response.data = { data: [] }
      const d = response?.data;
      if (Array.isArray(d)) return d;
      if (d && Array.isArray(d.data)) return d.data;
      return [];
    },

    async getReporteVentasFactura() {
      if (this.isBusy) return;

      this.resetMsgs();

      const fechainicio = $("#fechainicio").val();
      const fechafin = $("#fechafin").val();

      if (!fechainicio || !fechafin) {
        this.errorMsg = "Seleccione fecha inicio y fecha final.";
        return;
      }

      this.loading = true;
      this.busyText = "Consultando reporte...";

      try {
        const response = await this.reporteService.getListaMovimientosConciliacion(
          this.person,
          fechainicio,
          fechafin,
          GLOBAL.TIPO_ORIGEN.COMBUSTIBLE
        );

        this.reporte = Array.isArray(response.data) ? response.data : [];

        // Totales (mantengo tu lógica)
        this.totalventas = this.reporte.length;
        this.totalimpuestos = this.reporte.reduce((sum, item) => sum + (item.impuesto_total || 0), 0);
        this.totalCantidad = this.reporte.reduce((sum, item) => sum + (item.cantidad || 0), 0);
        this.totales = this.reporte.reduce((sum, item) => sum + (item.venta_total || 0), 0);

        this.fcantidad = GLOBAL.FORMATO_NUMBER(this.totalCantidad);
        this.ftotalimpuestos = GLOBAL.FORMATO_MONEY(this.totalimpuestos);
        this.ftotales = GLOBAL.FORMATO_MONEY(this.totales);
        this.fecha_inicio_reporte = fechainicio;
        this.fecha_final_reporte = fechafin;

        // Pintar en DataTable
        if (this.datatable) {
          this.datatable.clear();
          this.datatable.rows.add(this.reporte);
          this.datatable.draw(false);
        }

        if (this.reporte.length === 0) {
          this.infoMsg = "No se encontraron registros en el rango seleccionado.";
        }
      } catch (error) {
        try {
          let mensaje = error?.response?.data || "Error consultando reporte.";
          console.log(mensaje);


          // Mostrar mensaje de éxito
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.onmouseenter = Swal.stopTimer;
              toast.onmouseleave = Swal.resumeTimer;
            },
          });

          Toast.fire({
            icon: "error",
            title: mensaje,
          });


        } catch (error) { }
      } finally {
        this.loading = false;
        this.busyText = "";
      }
    },

    buildFilename() {
      const fi = ($("#fechainicio").val() || "").replace(/[: ]/g, "-");
      const ff = ($("#fechafin").val() || "").replace(/[: ]/g, "-");
      return `ventas_conciliadas_${fi}_${ff}.xlsx`;
    },

    async exportarExcel() {
      if (this.isBusy) return;

      this.resetMsgs();

      const fechainicio = $("#fechainicio").val();
      const fechafin = $("#fechafin").val();

      if (!fechainicio || !fechafin) {
        this.errorMsg = "Seleccione fecha inicio y fecha final.";
        return;
      }

      this.loadingExport = true;
      this.busyText = "Generando Excel, por favor espere...";

      try {
        const res = await this.reporteService.exportMovimientosConciliacionExcel(
          this.person,
          fechainicio,
          fechafin,
          GLOBAL.TIPO_ORIGEN.COMBUSTIBLE,
          null
        );

        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = this.buildFilename();
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);

        this.infoMsg = "Excel generado.";
      } catch (err) {
        console.error("Error exportando Excel:", err);
        this.errorMsg = "Error exportando Excel.";
      } finally {
        this.loadingExport = false;
        this.busyText = "";
      }
    },

    initializeDataTable() {
      // Importante: conserva la configuración COMPLETA de columnas (la que sí funciona)
      this.datatable = $("#table1").DataTable({
        data: this.reporte,
        columns: [
          { data: "fecha_full" },
          { data: "fecha" },
          { data: "hora", className: "text-right" },
          {
            data: "manguera",
            className: "text-center",
            render: (data, type, row) => `M.${row.manguera}`,
          },
          { data: "producto" },
          { data: "vendedor" },
          { data: "flota" },
          { data: "placa" },
          { data: "tercero_nombre" },
          { data: "ticket" },
          {
            className: "text-right",
            render: (data, type, row) => row.medios?.[0]?.medio_descripcion || "",
          },
          {
            className: "text-right",
            render: (data, type, row) => row.medios?.[1]?.medio_descripcion || "",
          },
          {
            className: "text-right",
            render: (data, type, row) => row.medios?.[2]?.medio_descripcion || "",
          },
          { data: "lect_inicial" },
          { data: "lect_final" },
          { data: "presion" },
          {
            className: "text-right",
            render: (data, type, row) => GLOBAL.FORMATO_MONEY_BASIC(row.precio),
          },
          {
            className: "text-center",
            render: (data, type, row) => GLOBAL.FORMATO_NUMBER(row.cantidad),
          },
          { data: "unidad_descripcion" },
          {
            className: "text-right",
            render: (data, type, row) => GLOBAL.FORMATO_MONEY_BASIC(row.venta_subtotal),
          },
          {
            className: "text-right",
            render: (data, type, row) => GLOBAL.FORMATO_MONEY_BASIC(row.descuento_total),
          },
          {
            className: "text-right",
            render: (data, type, row) => GLOBAL.FORMATO_MONEY_BASIC(row.venta_total),
          },
          {
            className: "text-right",
            render: (data, type, row) => GLOBAL.FORMATO_MONEY_BASIC(row.recaudar),
          },
          {
            className: "text-right",
            render: (data, type, row) => GLOBAL.FORMATO_MONEY_BASIC(row.recaudado),
          },
          {
            className: "text-right",
            render: (data, type, row) => GLOBAL.FORMATO_MONEY_BASIC((row.recaudado || 0) + (row.venta_total || 0)),
          },
          { data: "fac_consecutivo" },
          {
            className: "text-center",
            render: (data, type, row) =>
              row.factor != null ? GLOBAL.FORMATO_MONEY_BASIC(row.cantidad / row.factor) : "",
          },
          {
            className: "text-center",
            render: (data, type, row) =>
              row.factor != null ? GLOBAL.FORMATO_MONEY_BASIC(row.precio * row.factor) : "",
          },
          { data: "fact_hash" },
          { data: "fact_tercero_nit" },
          { data: "fact_tercero_nombre" },
          { data: "fact_fecha" },
        ],
        dom:
          "<'btt row'<'col-sm-2'l><'col-sm-4'B><'col-sm-6'f>>" +
          "<'row'<'col-sm-12'tr>>" +
          "<'btt row'<'col-sm-5'i><'col-sm-7'p>>",
        buttons: [
          {
            extend: "copyHtml5",
            text: '<i class="fa-regular fa-clipboard"></i>',
          },
          {
            extend: "excelHtml5",
            text: '<i class="fa-regular fa-file-excel"></i>',
          },
          {
            extend: "csvHtml5",
            text: '<i class="fa-solid fa-file-csv"></i>',
          },
          {
            extend: "pdfHtml5",
            text: '<i class="fa-regular fa-file-pdf"></i>',
          },
        ],
        scrollX: true,
        responsive: false,
        autoWidth: false,
        language: {
          url: "plugins/Spanish.json",
        },
      });
    },
  },
};
</script>

<style scoped>
.ml-1 {
  margin-left: 6px;
}

.mt-2 {
  margin-top: 10px;
}

.msg {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 6px;
  font-size: 13px;
  line-height: 18px;
}

.msg-info {
  color: #0b5ed7;
}

.msg-error {
  color: #dc3545;
}

.msg-muted {
  color: #6c757d;
}
</style>
